import { apiClient } from '@/services/apiClient';

/**
 * Update an employee's resource code.
 * Pass null for resourceCode to clear the resource code.
 */
export async function updateEmployeeResourceCode(
  employeeId: number,
  resourceCode: string | null
): Promise<{ success: boolean; message: string; resourceCode: string | null }> {
  return apiClient.patch<{ success: boolean; message: string; resourceCode: string | null }>(
    `/employees/${employeeId}/resource-code`,
    { resourceCode }
  );
}
